import { AvaliabilityTooltip } from "@admin/components/molecules/Tooltips";
import { getHoursAndMinutes } from "@enos-monorepo/lib";
import { useTranslation } from "react-i18next";

interface AvailabilityProps {
  availabilityTypeId: 1 | 2 | 3; // 1: available, 2: unavailable, 3: unknown
  startDateTime: string; // ISO string format
  endDateTime: string; // ISO string format
  reason?: string;
  id?: string;
}

export function AvailabilityInfo({
  availabilityTypeId,
  startDateTime,
  endDateTime,
  reason,
  id,
}: AvailabilityProps) {
  const { t } = useTranslation();

  if (!startDateTime || !endDateTime)
    return (
      <div>
        <AvaliabilityTooltip
          trigger={
            <i className={`ki-solid ki-question-2 text-xl text-[#5014D0]`} />
          }
          icon={
            <i className={`ki-solid ki-question-2 text-xl text-[#5014D0]`} />
          }
          title={t("shift.Availability Unknown")}
          description={t("shift.This personnel did not submit info")}
        />
      </div>
    );

  const startDate = new Date(startDateTime);
  const endDate = new Date(endDateTime);
  const dayStart = new Date(startDate);
  dayStart.setHours(0, 0, 0, 0);

  const dayEnd = new Date(endDate);
  dayEnd.setHours(23, 59, 0);

  const isFullDay =
    dayStart.getTime() === startDate.getTime() &&
    dayEnd.getTime() === endDate.getTime();

  const availabilitySymbol =
    availabilityTypeId === 1 ? (
      isFullDay ? (
        <div>
          <AvaliabilityTooltip
            trigger={
              <i
                className={`ki-solid ki-check-squared text-xl text-[#296573]`}
              />
            }
            icon={
              <i
                className={`ki-solid ki-check-squared text-xl text-[#296573]`}
              />
            }
            title={t("shift.This personnel is available")}
            description={
              t("shift.Available Hours") + ": " + t("availability.All Day")
            }
          />
        </div>
      ) : (
        <div>
          <AvaliabilityTooltip
            trigger={
              <i
                className={`ki-solid ki-minus-squared text-xl text-[#DFA000]`}
              />
            } // partiallyAvailable consists of available hours so we need unique ids
            icon={
              <i
                className={`ki-solid ki-minus-squared text-xl text-[#DFA000]`}
              />
            }
            title={t("shift.This personnel is partially available")}
            description={`${t("shift.Available Hours")}: ${getHoursAndMinutes(startDateTime)} - ${getHoursAndMinutes(endDateTime)}`}
          />
        </div>
      )
    ) : (
      <div>
        <AvaliabilityTooltip
          trigger={
            <i className={`ki-solid ki-cross-square text-xl text-[#8D4F61]`} />
          }
          icon={
            <i className={`ki-solid ki-cross-square text-xl text-[#8D4F61]`} />
          }
          title={t("shift.This personnel is not available")}
          description={`${t("shift.Unavailability Reason")}: ${reason}`}
        />
      </div>
    );

  return availabilitySymbol;
}
